// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CheckOrdersOrderDetail from './checkOrdersOrderDetail';
import React from 'react';

function CheckOrdersOrderDetailPage () {

    return (
        <AuthenticatedPage className="atp-page atp-check-orders-order-detail-page">
            <CheckOrdersOrderDetail />
        </AuthenticatedPage>
    );

}
CheckOrdersOrderDetailPage.displayNAme = 'CheckOrdersOrderDetailPage';

export default CheckOrdersOrderDetailPage;
